import {
	SET_SELECTED_GALLERY_IMAGES,
	TOGGLE_GALLERY_MODAL,
	TOGGLE_PHOTO_SLIDER,
	SET_JD_PHOTOS_ADD_DATA,
} from '../actions/types'

const initialState = {
	selectedImages: [],
	addModal: {
		show: false
	},
	deleteModal: {
		show: false
	},
	jdPhotosData: {
		variantId: null,
		curImageUrl: "",
	},
	isJdPhotoSlider: false,
	selectPhotoSlider: false
}

export default (state = initialState, action) => {
	const payload = action.payload;

	switch (action.type) {
		case SET_SELECTED_GALLERY_IMAGES: {
			return {
				...state,
				selectedImages: payload
			}
		}
		case TOGGLE_GALLERY_MODAL: {
			return {
				...state,
				...payload
			}
		}
		case TOGGLE_PHOTO_SLIDER: {
			const newState = {
				...state,
				...payload
			};
			if(!newState.selectPhotoSlider) {
				newState.isJdPhotoSlider = false;
			}
			return newState;
		}
		case SET_JD_PHOTOS_ADD_DATA: {
			const newState = {
				...state,
				jdPhotosData: {
					productId: null,
					curImageUrl: "",
					...payload
				}
			};
			return newState;
		}
		default:
			return state;
	}
}